interface GetMembershipCheckoutTimelineOnTodayStepTextConfig {
  firstPaymentCycle?: number;
  appendTheNextPromoMonthsText?: boolean;
  promoMonths?: number;
}

export const getMembershipCheckoutTimelineOnTodayStepText = (
  config: GetMembershipCheckoutTimelineOnTodayStepTextConfig
) => {
  const {
    firstPaymentCycle = 0,
    appendTheNextPromoMonthsText = false,
    promoMonths = 0,
  } = config;
  // When there are no promo months included and the first payment cycle is exactly 1
  if (!appendTheNextPromoMonthsText && firstPaymentCycle === 1) {
    return "First month adjusted + full second month";
  }

  // When the first payment cycle is 0
  if (!firstPaymentCycle) {
    let baseText = "Discounted price + first month adjusted";
    if (appendTheNextPromoMonthsText && promoMonths > 0) {
      // Adjusting for the scenario where there are promo months even if the first payment cycle is 0
      baseText +=
        promoMonths === 1 ? " + next month" : ` + next ${promoMonths} months`;
    }
    return baseText;
  }

  // Calculate the total months covered by the initial payment and promo periods
  const totalMonths =
    firstPaymentCycle + (appendTheNextPromoMonthsText ? promoMonths : 0);

  if (totalMonths === 1) {
    return "Discounted price + First month adjusted";
  }

  return `Discounted price + First month adjusted + next ${totalMonths} months`;
};
